import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface UiState {
  sidebarOpen: boolean
  theme: 'light' | 'dark' | 'system'
  loading: {
    global: boolean
    message: string | null
  }
  modal: {
    isOpen: boolean
    type: string | null
    data: Record<string, unknown> | null
  }
}

const initialState: UiState = {
  sidebarOpen: true,
  theme: 'system',
  loading: {
    global: false,
    message: null,
  },
  modal: {
    isOpen: false,
    type: null,
    data: null,
  },
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload
    },
    setTheme: (state, action: PayloadAction<UiState['theme']>) => {
      state.theme = action.payload
    },
    setGlobalLoading: (state, action: PayloadAction<{ loading: boolean; message?: string }>) => {
      state.loading.global = action.payload.loading
      state.loading.message = action.payload.message ?? null
    },
    openModal: (state, action: PayloadAction<{ type: string; data?: Record<string, unknown> }>) => {
      state.modal.isOpen = true
      state.modal.type = action.payload.type
      state.modal.data = action.payload.data ?? null
    },
    closeModal: (state) => {
      state.modal.isOpen = false
      state.modal.type = null
      state.modal.data = null
    },
  },
})

export const { toggleSidebar, setSidebarOpen, setTheme, setGlobalLoading, openModal, closeModal } =
  uiSlice.actions

export const uiReducer = uiSlice.reducer
